import React from "react";
import Slider from "react-slick";

import "../../../css/components/sliders/EmptySlider.scss";

const EmptySlider = (props) => {
  // Const slider settings
  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    className: "center empty-slider",
    centerPadding: "60px",
    centerMode: false,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: false,
    autoplaySpeed: 2000,
  };
  return (
    <section className={`empty-slider-container ${props.customClass ? props.customClass : ""}`}>
      <Slider {...sliderSettings}>{props.children}</Slider>
    </section>
  );
};

export default EmptySlider;
